export enum QueryStringKeyword {
  SEARCH_TERM = "search_term",
  SEARCH_COLUMNS = "search_columns",
  SORTING = "sorting",
  PAGE = "page",
  PAGE_SIZE = "page_size",
  SELECT = "select",
}
